module.exports = __webpack_public_path__ + "media/images/application/icons/icon-logout-519a18c1f75fa522d419fdc157635f46.svg";